(function () {
  function formatMoney(cents, format) {
    const amount = (cents / 100).toFixed(2);
    const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas.split('.')[0])
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  function updateTotal(form) {
    const total = form.querySelector('[data-pdp-total]');
    if (!total) return;
    let cents = parseInt(form.dataset.basePrice, 10) || 0;
    document.querySelectorAll(`input[form="${form.id}"]:checked`).forEach((input) => {
      cents += parseInt(input.dataset.price, 10) || 0;
    });
    total.textContent = formatMoney(cents, form.dataset.moneyFormat || '${{amount}}');
  }

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches('[data-personalize] input[type="radio"]')) return;
    const form = document.getElementById(input.getAttribute('form'));
    if (form) updateTotal(form);
  });

  // "No stickers" has no variant, so leave the sticker line out of the cart entirely.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('[data-pdp-form]')) return;
    const none = document.querySelector(`input[form="${form.id}"][data-sticker-none]`);
    const skip = none && none.checked;
    document.querySelectorAll(`input[form="${form.id}"][data-sticker-field]`).forEach((field) => {
      field.disabled = skip;
    });
    if (none) none.disabled = skip;
  });

  // Coming back via the browser's back button restores the page from cache; re-enable fields.
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-sticker-field], [data-sticker-none]').forEach((field) => {
      field.disabled = false;
    });
    document.querySelectorAll('[data-pdp-form]').forEach(updateTotal);
  });
})();
